import {TOGGLE_AI_SIDEBAR, ToggleAiSidebar} from "../actions";

export interface IAiSidebar {
  toggled: boolean;
}

export const initialState: IAiSidebar = {
  toggled: false
};

export function reducer(state: IAiSidebar = initialState, action: ToggleAiSidebar): any {

  switch (action.type) {

    case TOGGLE_AI_SIDEBAR:
      return {
        ...state,
        toggled: !state.toggled,
      };
  }

  return state;
}
